import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import "./ManagerLogin.css"; // ✅ Reuse same CSS

function ManagerLogin() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `https://devskillz-ifm6.onrender.com/api/auth/login`,
        formData,
        { withCredentials: true }
      );

      if (res.data.message) {
        alert("✅ Login successful!");
        navigate("/"); // redirect to home or dashboard
      }
    } catch (err) {
      setError(err.response?.data?.error || "❌ Invalid username or password");
    }
  };

  return (
    <div className="register-page">
      <div className="register-box">
        <h2>Welcome Back</h2>
        <p className="subtitle">Login to continue your learning 🚀</p>

        <form onSubmit={handleLogin} className="register-form">
          <div className="form-grid">
            <div>
              <input
                type="text"
                name="username"
                placeholder="Username"
                value={formData.username}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {error && <p className="error">{error}</p>}

          <button type="submit" className="submit-btn">
            Login
          </button>
        </form>

        {/* <p className="login-link">
          New here? <Link to="/StudentRegister">Sign Up</Link>
        </p> */}
      </div>
    </div>
  );
}

export default ManagerLogin;
